module.exports = __webpack_public_path__ + "static/img/f100eb5df64a8f6a3e92092eb71162f2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/youshi_jrx.png
// module id = gtrk
// module chunks = 1